import { DATA_SOURCE } from "@glitchful-dev/sol-apy-sdk";

import Images from "../../styles/image-library";

import type { CoinSymbols } from "./coinSymbols";
import { coinSymbols } from "./coinSymbols";
import type { TokenRecord } from "./token";

/** All cointokens used by marinade */
export const coinTokens: TokenRecord<CoinSymbols> = {
  [coinSymbols.MNDE]: {
    chainId: 101,
    address: "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    symbol: "MNDE",
    name: "Marinade",
    decimals: 9,
    logoURI: Images.icons_mnde,
    tags: [],
    coingeckoId: "marinade",
    fetchPrice: true,
    fetchBalance: true,
  },
  [coinSymbols.mSOL]: {
    chainId: 101,
    address: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    symbol: "mSOL",
    name: "Marinade Liquid Staking",
    decimals: 9,
    logoURI: Images.icons_mSOL,
    tags: [],
    coingeckoId: "msol",
    fetchPrice: true,
    fetchBalance: true,
    glitchfulURL:
      "https://thru.marinade.finance/glitchful-dev/sol-stake-pool-apy/master/db/marinade.csv",
    fetchSOLPrice: true,
  },
  [coinSymbols.SOL]: {
    chainId: 101,
    address: "So11111111111111111111111111111111111111112",
    symbol: "SOL",
    name: "Wrapped SOL",
    decimals: 9,
    logoURI:
      "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png",
    tags: [],
    coingeckoId: "solana",
    fetchPrice: true,
  },
  [coinSymbols.USDC]: {
    chainId: 101,
    address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    symbol: "USDC",
    name: "USD Coin",
    decimals: 6,
    logoURI:
      "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v/logo.png",
    tags: ["stablecoin"],
    coingeckoId: "usd-coin",
    fetchPrice: true,
    fetchBalance: true,
  },
  [coinSymbols.laineSOL]: {
    chainId: 101,
    address: "LAinEtNLgpmCP9Rvsf5Hn8W6EhNiKLZQti1xfWMLy6X",
    poolAddress: "2qyEeSAWKfU18AFthrF7JA8z8ZCi1yt76Tqs917vwQTV",
    symbol: "laineSOL",
    name: "Laine Stake",
    logoURI: Images.icons_laineSOL,
    decimals: 9,
    fetchBalance: true,
    glitchfulURL: DATA_SOURCE.LAINE_CSV,
    fetchSOLPrice: true,
  },
  [coinSymbols.cgntSOL]: {
    chainId: 101,
    address: "CgnTSoL3DgY9SFHxcLj6CgCgKKoTBr6tp4CPAEWy25DE",
    poolAddress: "CgntPoLka5pD5fesJYhGmUCF8KU1QS1ZmZiuAuMZr2az",
    symbol: "cgntSOL",
    name: "Cogent SOL",
    logoURI: Images.icons_cgntSOL,
    decimals: 9,
    fetchBalance: true,
    glitchfulURL: DATA_SOURCE.COGENT_CSV,
    fetchSOLPrice: true,
  },
  [coinSymbols.bSOL]: {
    chainId: 101,
    address: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
    poolAddress: "stk9ApL5HeVAwPLr3TLhDXdZS8ptVu7zp6ov8HFDuMi",
    symbol: "bSOL",
    name: "BlazeStake Staked SOL",
    logoURI: Images.icons_blazeSOL,
    decimals: 9,
    fetchBalance: true,
    glitchfulURL: DATA_SOURCE.SOLBLAZE_CSV,
    fetchSOLPrice: true,
  },
  [coinSymbols.daoSOL]: {
    chainId: 101,
    address: "GEJpt3Wjmr628FqXxTgxMce1pLntcPV4uFi8ksxMyPQh",
    poolAddress: "7ge2xKsZXmqPxa3YmXxXmzCp9Hc2ezrTxh6PECaxCwrL",
    symbol: "daoSOL",
    name: "daoSOL Token",
    logoURI: Images.icons_daoSOL,
    decimals: 9,
    fetchBalance: true,
    glitchfulURL: DATA_SOURCE.DAOPOOL_CSV,
    fetchSOLPrice: true,
  },
  [coinSymbols.jitoSOL]: {
    chainId: 101,
    address: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
    poolAddress: "Jito4APyf642JPZPx3hGc6WWJ8zPKtRbRs4P815Awbb",
    symbol: "jitoSOL",
    name: "Jito Staked SOL",
    logoURI: Images.icons_jitoSOL,
    decimals: 9,
    fetchBalance: true,
    glitchfulURL: DATA_SOURCE.JITO_CSV,
    fetchSOLPrice: true,
  },
  [coinSymbols.stSOL]: {
    chainId: 101,
    address: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    poolAddress: "",
    symbol: "stSOL",
    name: "Lido Staked SOL",
    logoURI: Images.icons_lidoSOL,
    decimals: 9,
    fetchBalance: true,
    glitchfulURL: DATA_SOURCE.LIDO_CSV,
    fetchSOLPrice: true,
  },
  [coinSymbols.jSOL]: {
    chainId: 101,
    address: "7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn",
    poolAddress: "CtMyWsrUtAwXWiGr9WjHT5fC3p3fgV8cyGpLTo2LJzG1",
    symbol: "jSOL",
    name: "JPOOL Solana Token",
    logoURI: Images.icons_jSOL,
    decimals: 9,
    fetchBalance: true,
    glitchfulURL: DATA_SOURCE.JPOOL_CSV,
    fetchSOLPrice: true,
  },
  [coinSymbols.lpSOL]: {
    chainId: 101,
    address: "LPmSozJJ8Jh69ut2WP3XmVohTjL4ipR18yiCzxrUmVj",
    symbol: "lpSOL",
    name: "Marinade LP token",
    decimals: 9,
    fetchBalance: true,
  },
};
